import { render, staticRenderFns } from "./DescriptionBlock.vue?vue&type=template&id=36394ca9&"
import script from "./DescriptionBlock.vue?vue&type=script&lang=js&"
export * from "./DescriptionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports